import httpClient from '../util/httpClient';
import { GLOBAL_API_DOMAIN } from '../config'

async function login(params) {
    let { data } = await httpClient.post('api/admin/login', params);
    return data;
}

async function qrLogin(params) {
    let { data } = await httpClient.post('api/admin/qrcode/login', params);
    return data;
}

async function logout() {
    let { data } = await httpClient.post('api/admin/logout', { noLoading: true });
    return data;
}

async function updatePassword(params) {
    let { data } = await httpClient.post('api/admin/updpwd', params);
    return data;
}

async function getQRCode(params) {
    let { data: { message, result, status } } = await httpClient.post(window.location.origin + '/common/qrcode/get', params);
    return result
}

async function checkQRCodeStatus(code) {
    let { data } = await httpClient.post(window.location.origin + `/common/qrcode/check`, { code }, { noLoading: true });
    return data;
}

/**
 * 获取左侧菜单栏
 */
async function getLeftMenuList() {
    let { data: { message, result, status } } = await httpClient.get(`api/admin/menu/mine`);
    let leftMenuList = []
    if (status == 200) {
        leftMenuList = result
    }
    return leftMenuList;
}
/**
 * 获取登录用户信息
 */
async function getUserInfo() {
    let { data: { message, result, status } } = await httpClient.get(`api/admin/me`, { noLoading: true });
    let userinfo = {}
    if (status == 200) {
        userinfo = result
    }
    return userinfo;
}
/**
 * 获取组织信息
 */
async function getOrgInfo() {
    let { data: { message, result, status } } = await httpClient.get(`api/organization`, { noLoading: true });
    let orginfo = {}
    if (status == 200) {
        orginfo = result
    }
    return orginfo;
}

async function goBackAdmin() {
    let { data: { message, result, status } } = await httpClient.get(`api/admin/goback`, { noLoading: true });
    return { message, result, status };
}
/**
 * 获取当前用户开通的平台{"AliPay":"支付宝","WeChatPay":"微信"}
 */
async function getPlatform() {
    let { data: { message, result, status } } = await httpClient.get(`api/organization/get-platform`, { noLoading: true });
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 获取发卡概况
 */
async function getECardStatis(params) {
    let { data: { message, result, status } } = await httpClient.get(`api/ecard/statis`, { params }, { noLoading: true });
    let statis = {}
    if (status == 200) {
        statis = result
    }
    return statis;
}
/**
 * 获取领卡情况数据
 */
async function getECardActiveInfo(params) {
    let { data: { message, result, status } } = await httpClient.get(`api/active-info`, { params });
    let data = {}
    if (status == 200) {
        data = result
    }
    return data;
}
/**
 * 获取校园卡用户列表
 * @param {*} params
 */
async function getECardUserList(params) {
    let { data: { message, result, status } } = await httpClient.get(`api/ecard/list-cards`, { params });
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 导出校园卡用户列表
 * @param {*} params
 */
async function exportECardUserList(params) {
    // let url = location.origin + GLOBAL_API_DOMAIN + `api/ecard/list/export/v2?` + Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&')
    // window.open(url)
    let { data: { message, result, status } } = await httpClient.get(`api/ecard/list/export/v2`, { params });
    if (status == 200) {
        return result
    }
}

/**
 * k12学校导出用户列表
 * @param {*} params
 */
async function exportK12UserList(params) {
    // let url = location.origin + GLOBAL_API_DOMAIN + `api/ecard/list/export/v2?` + Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&')
    // window.open(url)
    let { data: { message, result, status } } = await httpClient.get(`api/ecard/list/export/k12`, { params });
    if (status == 200) {
        return result
    }
}

/**
 * 切换校园卡用户状态
 * @param {*} url
 * @param {*} params
 */
async function toggleUserStatus(url, params) {
    let { data } = await httpClient.post(url, params, { noLoading: true });
    return data;
}

/**
 * 部门信息添删改查
 * @param {*} params
 */
async function CRUD_DEPARTMENT(params) {
    params.url = `api/department`
    let { data } = await httpClient(params);
    return data;
}

/**
 * 批量对校园卡用户添删改查
 * @param {*} params
 */
async function CRUD_BATCH_USER(params) {
    params.method = "POST"
    let { data } = await httpClient(params);
    return data;
}

/**
 * 后台刷新用户信息
 * @param {校园卡ID} id
 */
async function refreshUser(id) {
    let { data } = await httpClient.post(`api/organization/ext/refresh`, {}, { params: { id } });
    return data;
}

/**
 * 获取可用的校园卡列表
 */
async function getECardList(params) {
    let { data: { message, result, status } } = await httpClient.get(`manage-api/v2/card-type-list`,{ params });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 文件上传
 * @param {*} file
 */
async function uploadFile(file) {
    let formData = new FormData()
    formData.append('file', file)
    let { data } = await httpClient.post('api/upload/file', formData, {params:{'isPrivate': true}});
    return data;
}
/**
 * 导入EXCEL数据
 * @param {*} params
 */
async function importECardExcel(params) {
    let { data } = await httpClient.post('api/ecard/import', params);
    return data;
}

/**
 * 对校园卡用户添删改查
 * @param {*} params
 */
async function CRUD_USER(params) {
    if (!params.url) {
        params.url = `api/ecard`
    }
    let { data } = await httpClient(params);
    return data;
}

/**
 * 后台添加用户获取限制信息
 */
async function getUserLimitFields() {
    let { data: { message, result, status } } = await httpClient.get(`api/organization/limit-fields`);
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 获取二级部门列表
 */
async function getLevel2Dept() {
    let { data } = await httpClient.get(`api/department/two`);
    return data;
}

/**
 * 批量删除部门
 * @param {Array} params
 */
async function batchDelDept(params) {
    let { data } = await httpClient.post(`api/department/delbatch`, params);
    return data;
}

/**
 * 获取当前学校(可用)的所有权限列表(简版)
 */
async function getPrivilege() {
    let { data: { message, result, status } } = await httpClient.get(`api/ecard/privilege`);
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 获取当前学校(可用+不可用)的所有权限列表(完整版)
 */
async function getPrivilegeList(params) {
    let { data: { message, result, status } } = await httpClient.get(`api/ecard/privilege/list`, { params });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 添删改查权限
 * @param {*} params
 */
async function CRUD_PRIVILEGE(params) {
    if (!params.url) {
        params.url = `api/ecard/privilege`
    }
    let { data } = await httpClient(params);
    return data;
}

/**
 * 获取消费记录支付平台
 */
async function getPayChannels() {
    let { data: { message, result, status } } = await httpClient.get(`api/get-paychannel`);
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 获取消费记录列表
 * @param {*} params
 */
async function getConsumeDataList(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/trade-info/search`, params);
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 导出消费记录
 */
async function exportTradeInfo(params) {
    let url = location.origin + GLOBAL_API_DOMAIN + `api/trade-info/export?` + Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&')
    window.open(url)
}

/**
 * 添删改查校园卡
 * @param {*} params
 */
async function CRUD_ECARD(params) {
    if (!params.url) {
        params.url = `manage-api/v2/card-type`
    }
    let { data } = await httpClient(params);
    return data;
}

/**
 * 获取支付宝卡包导航所需图标资源
 */
async function getAliPayIconList() {
    let { data: { message, result, status } } = await httpClient.get(`api/ali/image/icon/type?id=1`);
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 根据标题关键字查询支付宝卡包已删除导航列表
 * @param {校园卡ID} cardTypeId
 * @param {导航标题} key
 */
async function getAliPayDeleteNavigationList(cardTypeId, key, platForm) {
    let { data: { message, result, status } } = await httpClient.post(`api/ecard/type/navigation/deleted/list`, {
        cardTypeId,
        platForm,
        title: key
    }, { noLoading: true });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 获取卡包导航列表
 */
async function getNavigationList(id, platForm = 'AliPay') {
    let { data: { message, result, status } } = await httpClient.get(`api/ecard/type/navigation/list`, { params: { id, platForm } });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 获取支付宝卡包分组列表
 * @param {校园卡ID} id
 */
async function getAliPayGroupList(id) {
    let { data: { message, result, status } } = await httpClient.get(`api/cardtype/group`, { params: { id } });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 新建支付宝分组
 * @param {校园卡ID} cardTypeId
 * @param {分组名称} groupName
 */
async function createAliPayGroup(cardTypeId, groupName) {
    let { data } = await httpClient.post(`api/cardtype/group/create`, { cardTypeId, groupName });
    return data;
}

/**
 * 删除支付宝分组
 * @param {分组ID} groupId
 */
async function deleteAliPayGroup(groupId) {
    let { data } = await httpClient.post(`api/cardtype/group/delete`, { groupId });
    return data;
}

/**
 * 更新支付宝分组
 * @param {分组ID} groupId
 * @param {分组名称} groupName
 */
async function updateAliPayGroup(groupId, groupName) {
    let { data } = await httpClient.post(`api/cardtype/group/update`, { groupId, groupName });
    return data;
}

/**
 * 更新支付宝分组列表排序
 */
async function updateAliPayGroupListSort(ids) {
    let { data } = await httpClient.post(`api/cardtype/group/sort`, { ids });
    return data;
}

/**
 * 添删改查导航
 */
async function CRUD_NAVIGATION(params) {
    if (!params.url) {
        params.url = `api/ecard/type/navigation`
    }
    let { data } = await httpClient(params);
    return data;
}

/**
 * 更新导航列表排序
 */
async function updateNavigationListSort(ids) {
    let { data } = await httpClient.post(`api/ecard/type/navigation/sort`, { ids });
    return data;
}

/**
 * 发布卡包
 */
async function publishEcard(tppCardTypeId) {
    let { data } = await httpClient.post(`api/ecard/type/publish`, { id: tppCardTypeId });
    return data;
}

/**
 * 获取微信应用广场导航所需图标资源
 * @param {模块类型id [1:卡包,2:应用中心]} id
 * @param {平台类型platForm  ['AliPay', 'WeChatPay']} platForm
 */
async function getWeChatPayIconList(platform, type) {
    let platForm = "WeChatPay";
    let id = 2;
    if(platform) {
      platForm = platform;
    }
    if(type) {
      id = type;
    }
    let { data: { message, result, status } } = await httpClient.get(`api/ali/image/icon/type/v2`, { params: { id, platForm } });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 获取微信应用广场导航列表
 * @param {校园卡ID} id
 */
async function getWeChatPayNavigationList(id) {
    let { data: { message, result, status } } = await httpClient.get(`api/page/navigation/list/v2`, { params: { id, platForm: "WeChatPay" } });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 获取云瓣刷脸付K12应用广场导航列表
 * @param {校园卡ID} id
 */
async function getK12NavigationList(params) {
    let { data: { message, result, status } } = await httpClient.get(`api/super/page/navigation/list`, { params });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 获取云瓣刷脸付k12应用广场分组列表
 * @param {校园卡ID} id
 */
async function getK12GroupList(params) {
    let { data: { message, result, status } } = await httpClient.get(`api/super/page/navigation/group`, { params });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 新建支付宝云瓣刷脸付k12应用广场分组
 * @param {校园卡ID} cardTypeId
 * @param {分组名称} groupName
 */
async function createK12Group(params) {
    let { data } = await httpClient.post(`api/super/page/navigation/group/create`, params);
    return data;
}

/**
 * 删除支付宝云瓣刷脸付k12应用广场分组
 * @param {分组ID} groupId
 */
async function deleteK12Group(groupId) {
    let { data } = await httpClient.post(`api/super/page/navigation/group/delete`, { groupId });
    return data;
}

/**
 * 更新支付宝云瓣刷脸付k12应用广场分组
 * @param {分组ID} groupId
 * @param {分组名称} groupName
 */
async function updateK12Group(groupId, groupName) {
    let { data } = await httpClient.post(`api/super/page/navigation/group/update`, { groupId, groupName });
    return data;
}

/**
 * 更新支付宝云瓣刷脸付k12应用广场分组列表排序
 */
async function updateK12GroupListSort(ids) {
    let { data } = await httpClient.post(`api/super/page/navigation/group/sort`, { ids });
    return data;
}

/**
 * 获取轻松付应用广场导航列表
 * @param {校园卡ID} id
 */
async function getWechatNavigationList(id) {
    let { data: { message, result, status } } = await httpClient.get(`api/super/page/navigation/list`, { params: { id, platForm: "WeChatPay", appType: "MINI_ESP" } });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 获取轻松付应用广场分组列表
 * @param {校园卡ID} id
 */
async function getWechatGroupList(id, orgId) {
    let { data: { message, result, status } } = await httpClient.get(`api/super/page/navigation/group`, { params: { id, orgId, platForm: 'WeChatPay', appType: "MINI_ESP"} });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 更新支付宝应用排序
 */
async function updateK12ListSort(ids) {
    let { data } = await httpClient.post(`api/super/page/navigation/sort`, { ids });
    return data;
}

/**
 * 获取微信应用广场分组列表
 * @param {校园卡ID} id
 */
async function getWeChatPayGroupList(id) {
    let { data: { message, result, status } } = await httpClient.get(`api/page/navigation/group`, { params: { id, platForm: 'WeChatPay' } });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 新建微信应用广场分组
 * @param {校园卡ID} cardTypeId
 * @param {分组名称} groupName
 */
async function createWeChatPayGroup(cardTypeId, groupName) {
    let { data } = await httpClient.post(`api/page/navigation/group/create`, { cardTypeId, groupName, platForm: 'WeChatPay' });
    return data;
}

/**
 * 删除微信应用广场分组
 * @param {分组ID} groupId
 */
async function deleteWeChatPayGroup(groupId) {
    let { data } = await httpClient.post(`api/page/navigation/group/delete`, { groupId });
    return data;
}

/**
 * 更新微信应用广场分组
 * @param {分组ID} groupId
 * @param {分组名称} groupName
 */
async function updateWeChatPayGroup(groupId, groupName) {
    let { data } = await httpClient.post(`api/page/navigation/group/update`, { groupId, groupName });
    return data;
}

/**
 * 更新微信应用广场分组列表排序
 */
async function updateWeChatPayGroupListSort(ids) {
    let { data } = await httpClient.post(`api/page/navigation/group/sort`, { ids });
    return data;
}

/**
 * 添删改查微信应用广场应用(导航)
 */
async function CRUD_WECHATPAY_NAVIGATION(params) {
    if (!params.url) {
        params.url = `api/page/navigation/v2`
    }
    let { data } = await httpClient(params);
    return data;
}

/**
 * 更新微信应用广场应用(导航)列表排序
 */
async function updateWeChatPayNavigationListSort(ids) {
    let { data } = await httpClient.post(`api/page/navigation/sort`, { ids });
    return data;
}

/**
 * 更新校园卡sample图片
 * @param {校园卡ID} cardTypeId
 * @param {校园卡sample图片URL} sample
 */
async function updateWechatPaySample(cardTypeId, sample) {
    let { data } = await httpClient.post(`api/ecard/type/cardtype/sample/update`, { cardTypeId, sample, platForm: 'WeChatPay' });
    return data;
}

/**
 * 根据标题关键字查询应用广场已删除导航列表
 * @param {校园卡ID} cardTypeId
 * @param {导航标题} key
 */
async function getWeChatPayDeleteNavigationList(cardTypeId, key, platForm) {
    let { data: { message, result, status } } = await httpClient.post(`api/page/navigation/deleted/list`, {
        cardTypeId,
        platForm,
        title: key
    }, { noLoading: true });
    if (status == 200) {
        return result
    }
    return [];
}

/*UniPay*/

/**
 * 获取微信应用广场导航列表
 * @param {校园卡ID} id
 */
async function getUniPayNavigationList(id) {
    let { data: { message, result, status } } = await httpClient.get(`api/page/navigation/list/v2`, { params: { id, platForm: "UniPay" } });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 获取微信应用广场分组列表
 * @param {校园卡ID} id
 */
async function getUniPayGroupList(id) {
    let { data: { message, result, status } } = await httpClient.get(`api/page/navigation/group`, { params: { id, platForm: 'UniPay' } });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 新建微信应用广场分组
 * @param {校园卡ID} cardTypeId
 * @param {分组名称} groupName
 */
async function createUniPayGroup(cardTypeId, groupName) {
    let { data } = await httpClient.post(`api/page/navigation/group/create`, { cardTypeId, groupName, platForm: 'UniPay' });
    return data;
}

/**
 * 删除微信应用广场分组
 * @param {分组ID} groupId
 */
async function deleteUniPayGroup(groupId) {
    let { data } = await httpClient.post(`api/page/navigation/group/delete`, { groupId });
    return data;
}

/**
 * 更新微信应用广场分组
 * @param {分组ID} groupId
 * @param {分组名称} groupName
 */
async function updateUniPayGroup(groupId, groupName) {
    let { data } = await httpClient.post(`api/page/navigation/group/update`, { groupId, groupName });
    return data;
}

/**
 * 更新微信应用广场分组列表排序
 */
async function updateUniPayGroupListSort(ids) {
    let { data } = await httpClient.post(`api/page/navigation/group/sort`, { ids });
    return data;
}

/**
 * 添删改查微信应用广场应用(导航)
 */
async function CRUD_UNIPAY_NAVIGATION(params) {
    if (!params.url) {
        params.url = `api/page/navigation/v2`
    }
    let { data } = await httpClient(params);
    return data;
}

/**
 * 更新微信应用广场应用(导航)列表排序
 */
async function updateUniPayNavigationListSort(ids) {
    let { data } = await httpClient.post(`api/page/navigation/sort`, { ids });
    return data;
}

/**
 * 更新校园卡sample图片
 * @param {校园卡ID} cardTypeId
 * @param {校园卡sample图片URL} sample
 */
async function updateUniPaySample(cardTypeId, sample) {
    let { data } = await httpClient.post(`api/ecard/type/cardtype/sample/update`, { cardTypeId, sample, platForm: 'UniPay' });
    return data;
}

/**
 * 根据标题关键字查询应用广场已删除导航列表
 * @param {校园卡ID} cardTypeId
 * @param {导航标题} key
 */
async function getUniPayDeleteNavigationList(cardTypeId, key, platForm) {
    let { data: { message, result, status } } = await httpClient.post(`api/page/navigation/deleted/list`, {
        cardTypeId,
        platForm,
        title: key
    }, { noLoading: true });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 获取帮助列表
 * @param {*} params
 */
async function getGuideList(params) {
    let { data: { message, result, status } } = await httpClient.get(`api/guide/list`, params);
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 添删改查帮助信息
 *
 */
async function CRUD_GUIDE(params) {
    let { data } = await httpClient(`api/guide`, params);
    return data;
}

/**
 * 图片上传
 */
async function uploadImage(imgFile) {
    let formData = new FormData()
    formData.append('file', imgFile)
    let { data } = await httpClient.post(`api/upload/image`, formData);
    return data;
}

/**
 * 获取使用记录
 * @param {*} params
 */
async function getRecordList(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/ecard/use-records/search`, params);
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 添删改查应用
 * @param {*} params
 */
async function CRUD_APPLICATION(params) {
    if (!params.url) {
        params.url = `api/application`
    }
    let { data } = await httpClient(params);
    return data;
}

/**
 * 添删改查机器
 * @param {*} params
 */
async function CRUD_MACHINE(params) {
    if (!params.url) {
        params.url = `api/application/machine`
    }
    let { data } = await httpClient(params);
    return data;
}

/**
 * 获取应用密钥
 */
async function getPublicKey(id) {
    let { data: { message, result, status } } = await httpClient.get(`api/application/public-key`, { params: { id } });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 添删改查子账户
 * @param {*} params
 */
async function CRUD_SUBADMIN(params) {
    if (!params.url) {
        params.url = `api/sub-admin`
    }
    let { data } = await httpClient(params);
    return data;
}

/**
 * 超管学校管理列表
 */
async function getOrganizationList(params) {
    let { data: { message, result, status } } = await httpClient.get(`api/organization/list`, { params }, { noLoading: true });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 超管学校列表修改账户
 */
async function getOrgUpdate(params) {
    let { data } = await httpClient.post(`super-api/org/update`, params);
    return data;
}

/**
 * 超管学校列表添加账户
 */
async function getOrgAdd(params) {
    let { data } = await httpClient.post(`api/organization/v2`, params);
    return data;
}
/*
 * 超管页面支付宝微信认证开启关闭
 */
async function getOrganizationStatus(params) {
    let { data } = await httpClient.post(params.url, params);
    return data;
}

/*
 *超管查看密码
 */
async function getAdminCode(params) {
    if (!params.url) {
        params.url = `api/admin/code`
    }
    let { data } = await httpClient(params);
    return data;
}

/*
 *超管查询密码是否可以查看
 */
async function getAdminStatus(params) {
    let { data } = await httpClient.post(`api/admin/code/status`, params);
    return data;
}

/*
 *超管获取所有的认证方式
 */
async function getValidTypes(params) {
    let { data } = await httpClient.get(`api/organization/valid-types`, { params }, { noLoading: true });
    return data;
}

/*
 * 超管获取支付宝认证信息
 */
async function getAliPayApp(params) {
    let { data } = await httpClient.get(`api/organization/query/alipay/app`, { params }, { noLoading: true });
    return data;
}

/*
 * 超管获取微信认证信息
 */
async function getWeChatApp(params) {
    let { data } = await httpClient.get(`api/organization/query/wechat/app`, { params }, { noLoading: true });
    return data;
}

/*
 * 超管获取手机号验证信息
 */
async function getPhoneApp(params) {
    let { data } = await httpClient.get(`api/super/phone/verify`, { params }, { noLoading: true });
    return data;
}

/*
 *微信实名认证设置免实名状态
*/
async function setRealverify(params) {
    let { data } = await httpClient.post(`api/ecard/set/realverify`, params);
    return data;
}
/*
 * 添加、修改支付宝认证方式
 */
async function getAliPay(params) {
    let { data } = await httpClient.post(`api/organization/setup/alipay`, params);
    return data;
}

/*
 * 添加、修改微信认证方式
 */
async function getWeChatPay(params) {
    let { data } = await httpClient.post(`api/organization/setup/WeChatPay`, params);
    return data;
}

/*
 * 添加、修改微信认证方式
 */
async function getUniPay(params) {
    let { data } = await httpClient.post(`api/organization/setup/UniPay`, params);
    return data;
}

/*
 * 设置手机管理认证方式
 */
async function setPhoneVerifyType(params) {
    let { data } = await httpClient.post(`api/super/phone/set/verify`, params);
    return data;
}

/*
 * 切换学校
 */
async function getChangeSchool(orgId) {
    let formData = new FormData();
    formData.append('orgId', orgId);
    let { data } = await httpClient.post(`api/admin/switch`, formData);
    return data;
}

/*
 * 超管用户管理获取学校
 */
async function getOrgs(params) {
    let { data } = await httpClient.post(`api/organization/orgs`, params);
    return data;
}

/**
 * 超管获取测试校园卡用户列表
 *
 */
async function getTestUserList(params) {
    let { data: { message, result, status } } = await httpClient.get(`api/ecard/hide/list`, { params });
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 超管获取测试组织信息
 *
 */
async function getDepartment(params) {
    params.url = `api/department/hide/list`
    let { data } = await httpClient(params);
    return data;
}

/*
 *超管用户管理添加用户
 *
 */
async function getAddbach(params) {
    let { data } = await httpClient.post(`api/ali/user/addbach`, params);
    return data;
}

/*
 *超管用户管理修改用户
 *
 */
async function getUpdbach(params) {
    let { data } = await httpClient.post(`api/ali/user/updbach`, params);
    return data;
}

/*
 * 超管删除用户
 *
 */
async function getDelbach(params) {
    let { data } = await httpClient.post(`api/ali/user/delbach`, params);
    return data;
}

/*
 * 超管查询信息
 */
async function getQuick(params) {
    let { data } = await httpClient.post(`api/ali/user/quick`, params);
    return data;
}

/*
  普通用户扫码绑定
*/
async function bind(params) {
    let { data } = await httpClient.post('api/admin/qrcode/bind', params);
    return data;
}

/*
  普通用户扫码解绑
*/
async function unbind(params) {
    let { data } = await httpClient.post('api/admin/qrcode/unbind', params);
    return data;
}

/*
  卡包设置获取设置类型 api/ecard/type/navigation
*/
async function getTypeNavigation(params) {
    let { data } = await httpClient.get(`api/ecard/type/navigation`, { params }, { noLoading: true });
    return data;
}

// async function getLeftMenuList() {
//     let { data } = await httpClient.get(`api/admin/menu/mine`, { params: { keyWord }, noLoading: true });
//     return data;
// }

/**
 * 超管代扣添删改查 2020.07.29 替换超管代扣管理创建和修改接口
 * @param {*} params
 */
async function MANAGE_WITHHOLD(params) {
    if (!params.url) {
        params.url = `api/dk`
    }
    let { data } = await httpClient(params);
    return data;
}

/*
 *超管更新代扣状态
*/
async function dkSetStatus(params) {
    let { data } = await httpClient.post('api/dk/set/status?id=' + params.id + '&status=' + params.status);
    return data;
}

/*
*获取实体卡列表
*/
async function dkUserList(params) {
    let { data: { message, result, status } } = await httpClient.get(`api/dk/user/list`, { params });
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 实体卡导入EXCEL数据
 * @param {*} params
 */
async function importUserExcel(params) {
    let { data } = await httpClient.post('api/dk/user/import', params);
    return data;
}

/*
*绑定实体卡
*/
async function userBind(params) {
    let { data } = await httpClient.post('api/dk/user/bind', params);
    return data;
}

/*
*解绑实体卡
*/
async function userUnBind(params) {
    let { data } = await httpClient.get(`api/dk/user/unbind`, { params });
    return data;
}

/*
*启用实体卡
*/
async function userEnable(params) {
    let { data } = await httpClient.post(`api/dk/user/set/status`, params);
    return data;
}

/*
*获取实体卡详情
*/
async function userDetail(params) {
    let { data } = await httpClient.get(`api/dk/user/detail`, { params });
    return data;
}


/*
*设置实体卡状态
*/

async function setupCardStatus(params) {
    let { data } = await httpClient.post('api/organization/setup/card/status', params);
    return data;
}

/*
*设置校园钱包状态
*/

async function setupWalletStatus(params) {
    let { data } = await httpClient.post('api/organization/setup/wallet/status', params);
    return data;
}

/*
*获取实体卡使用说明
*/

async function cardexplainList(params) {
    let { data } = await httpClient.get('api/cardexplain/list', {params});
    return data;
}

/*
*更新实体卡使用说明状态
*/

async function cardexplainStatus(params) {
    let { data } = await httpClient.post('api/cardexplain/status', params);
    return data;
}

/*
*实体卡使用说明排序
*/

async function cardexplainSort(params) {
    let { data } = await httpClient.post('api/cardexplain/sort', params);
    return data;
}

/*
*获取实体卡详情
*/

async function cardexplain(params) {
    let { data } = await httpClient.get('api/cardexplain', {params});
    return data;
}

/*
*更新实体卡使用说明
*/

async function cardexplainUpdate(params) {
    let { data } = await httpClient.post('api/cardexplain/update', params);
    return data;
}

/*
*创建实体卡使用说明
*/

async function cardexplainCreate(params) {
    let { data } = await httpClient.post('api/cardexplain/create', params);
    return data;
}

/*
*超管菜单管理获取管理员接口
*/

async function getAdminList(params) {
    let { data } = await httpClient.post('api/super/admin/list', params);
    return data;
}

/*
*超管获获取菜单接口
*/

async function menuList(params) {
    let {  data: { message, result, status } } = await httpClient.get('api/super/admin/menu/list', {params});
    return result;
}
/**
 * 添删改菜单
 */
async function MENU_ACTION(params) {
    if (!params.url) {
        params.url = `api/super/admin/menu/create`
    }
    let { data } = await httpClient(params);
    return data;
}
/**
 * 左侧菜单排序
 */
async function adminMenuSort(mids) {
    let { data } = await httpClient.post(`api/super/admin/menu/sort`, { mids });
    return data;
}
/*
*超管获取管理员菜单
*/

async function adminMenuGet(params) {
    let {  data: { message, result, status } } = await httpClient.get('api/super/admin/menu/get', {params});
    return result;
}
/**
 * 管理员分配菜单
 */
async function adminMenuSet(params) {
    let { data } = await httpClient.post(`api/super/admin/menu/set`, params);
    return data;
}

/**
 * 获取校园卡用户导入列表
 * @param {*} params
 */
async function getECardUserImportList(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/ecard/import/list`, params);
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 获取校园卡用户导入记录详情
 * @param {*} params
 */
async function getECardUserImportDetail(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/ecard/import/record/list`, params);
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 获取校园卡用户导出记录列表
 * @param {*} params
 */
async function getECardUserExportList(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/ecard/export/list`, params);
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 导入用户附件下载
 * @param {*} params
 */
async function importECardUser(params) {
    let {  data: { message, result, status } } = await httpClient.get('api/ecard/import/detail/download', {params});
    return result;
}

/**
 * 导出用户附件下载
 * @param {*} params
 */
async function exportECardUser(params) {
    let {  data: { message, result, status } } = await httpClient.get('api/ecard/export/detail/download', {params});
    return result;
}
/**
 * 获取名单管理列表
 * @param {*} params
 */
async function getPhoneNameList(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/phone/list/search`, params );
    if (status == 200) {
        return result
    }
    return {};
}
/**
 * 名单管理添删改查
 * @param {*} params
 */
async function PHONE_MANAGE(params) {
    params.url = `api/phone/list`
    let { data } = await httpClient(params);
    return data;
}

/**
 * 名单管理单个解绑
 * @param {*} params
 */
async function phoneUnbind(id) {
    let { data } = await httpClient.post(`api/phone/list/unbind?id=`+ id);
    return data;
}

/**
 * 名单管理批量解绑
 * @param {*} params
 */
async function phoneListUnbind(params) {
    let { data } = await httpClient.post(`api/phone/list/batch/unbind`, params );
    return data;
}

/**
 * 名单管理批量删除
 * @param {*} params
 */
async function phoneListDelete(params) {
    let { data } = await httpClient.post(`api/phone/list/batch/del`, params );
    return data;
}

/**
 * 导入名单数据
 * @param {*} params
 */
async function importPhoneImport(params) {
    let { data } = await httpClient.post('api/phone/list/import', params);
    return data;
}

/**
 * 获取号池管理列表
 * @param {*} params
 */
async function getPhonePoolList(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/phone/pool/search`, params );
    if (status == 200) {
        return result
    }
    return {};
}
/**
 * 号池管理添删改查
 * @param {*} params
 */
async function PHONE_POOL(params) {
    params.url = `api/phone/pool`
    let { data } = await httpClient(params);
    return data;
}

/**
 * 号池管理单个解绑
 * @param {*} params
 */
async function phonePoolUnbind(id) {
    let { data } = await httpClient.post(`api/phone/pool/unbind?id=`+ id);
    return data;
}

/**
 * 号池管理批量解绑
 * @param {*} params
 */
async function phonePoolListUnbind(params) {
    let { data } = await httpClient.post(`api/phone/pool/batch/unbind`, params );
    return data;
}

/**
 * 号池管理批量删除
 * @param {*} params
 */
async function phonePoolListDelete(params) {
    let { data } = await httpClient.post(`api/phone/pool/batch/del`, params );
    return data;
}

/**
 * 导入号池数据
 * @param {*} params
 */
async function importPhonePoolImport(params) {
    let { data } = await httpClient.post('api/phone/pool/import', params);
    return data;
}

/**
 * 获取手机号管理列表
 * @param {*} params
 */
async function getPhoneNumberList(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/phone/search`, params );
    if (status == 200) {
        return result
    }
    return {};
}
/**
 * 手机号管理添删改查
 * @param {*} params
 */
async function PHONE_NUMBER(params) {
    params.url = `api/phone`
    let { data } = await httpClient(params);
    return data;
}

/**
 * 手机号管理单个解绑
 * @param {*} params
 */
async function phoneNumberUnbind(id) {
    let { data } = await httpClient.post(`api/phone/unbind?id=`+ id);
    return data;
}

/**
 * 手机号管理批量解绑
 * @param {*} params
 */
async function phoneNumberListUnbind(params) {
    let { data } = await httpClient.post(`api/phone/batch/unbind`, params );
    return data;
}

/**
 * 手机号管理批量删除
 * @param {*} params
 */
async function phoneNumberListDelete(params) {
    let { data } = await httpClient.post(`api/phone/batch/del`, params );
    return data;
}

/**
 * 导入手机号数据
 * @param {*} params
 */
async function importPhoneNumberImport(params) {
    let { data } = await httpClient.post('api/phone/import', params);
    return data;
}

/**
 * 获取手机号管理子菜单
 * @param {*} params
 */
async function getPhoneSubmenu(params) {
    let { data: { message, result, status } } = await httpClient.get('api/phone/submenu', {params});
    return result;
}

/*
 * 设置学校外码
 */
async function setSchoolCode(params) {
    let { data } = await httpClient.post(`api/org/school/code/wx-add`, params);
    return data;
}

/*
 * 超管获取学校外码
 */
async function getSchoolApp(params) {
    let { data } = await httpClient.post(`api/org/school/code/list`, {}, {params});
    return data;
}

/*
 * 超管获取校外领卡设置信息
 */
async function getInterimCard(params) {
    let { data } = await httpClient.get(`api/super/card/off/campus/detail`, {params});
    return data;
}

/*
 * 超管获取卡类型列表
 */
async function getCardTypeList(params) {
    let { data } = await httpClient.get(`api/super/card/off/campus/cards`, {params});
    return data;
}

/*
 * 超管设置校外领卡信息
 */
async function updateInterimCard(params) {
    let { data } = await httpClient.post(`api/super/card/off/campus/update`, params);
    return data;
}

/**
 * 导出导出手机号管理表
 * @param {*} params
 */
async function exportPhoneNumberList(params) {
    let { data } = await httpClient.post(`api/phone/export`, params);
    return data;
}

/**
 * 获取手机号管理导出记录列表
 * @param {*} params
 */
async function getPhoneNumberExportList(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/phone/export/search`, params);
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 手机号管理导出用户附件下载
 * @param {*} params
 */
async function exportPhoneNumber(params) {
    let {  data: { message, result, status } } = await httpClient.get('api/phone/export/detail/download', {params});
    return result;
}

/**
 * k12学校获取微信小程序扫码图片
 * @param {*} params
 */
async function getWxCode(params) {
    let {  data: { message, result, status } } = await httpClient.get('api/wx/mini/face/get-wx-code-img', {params});
    return result;
}

/**
 * k12学校获取跳转授权链接接口
 * @param {*} params
 */
async function getAuth(params) {
    let {  data: { message, result, status } } = await httpClient.get('api/dk/get-app-oauth-token-url', {params});
    return result;
}

/**
 * k12学校首页获取统计
 * @param {*} params
 */
async function getK12Count(params) {
    let {  data: { message, result, status } } = await httpClient.get('api/dk/get-k12-count', {params});
    return result;
}

/**
 * k12学校超管关闭微信人脸支付
 * @param {*} params
 */
async function closeK12WeChat(params) {
    let data = await httpClient.get('api/org/school/code/wx-close-k12', {params});
    return data;
}

/**
 * k12学校超管获取支付宝人脸支付
 * @param {*} params
 */
async function getK12Ali(params) {
    let { data } = await httpClient.get('api/org/school/code/ali-k12-get', {params});
    return data;
}

/**
 * k12学校超管获取微信人脸支付
 * @param {*} params
 */
async function getK12WeChat(params) {
    let { data } = await httpClient.get('api/org/school/code/wx-k12-get', {params});
    return data;
}

/**
 * k12学校超管关闭支付宝人脸支付
 * @param {*} params
 */
async function closeAliK12(params) {
    let { data } = await httpClient.get('api/org/school/code/ali-close-k12', {params});
    return data;
}

/**
 * k12学校超管设置支付宝人脸支付
 * @param {*} params
 */
async function setAliK12(params) {
    let  { data } = await httpClient.post('api/org/school/code/ali-open-k12', params);
    return data;
}

/**
 * k12学校异常数据处理
 * @param {*} params
 */
async function closeKidsSuper(params) {
    let  { data } = await httpClient.post('api/org/school/code/closeKidsSuper', params);
    return data;
}

/**
 *拉取授权信息
 *
 */
async function getToken(params) {
   let { data } = await httpClient.get('api/ali/mini/contract/get-auth-token-from-partner', {params});
   return data;
}

/*
 *查询领卡提示信息
 */
async function ecardErrorTip() {
  let { data } = await httpClient.get('api/ecard/error/tip');
  return data;
}

/*
 *查询领卡错误信息
 */
async function ecardErrorRecordList(params) {
  let { data: { message, result, status } } = await httpClient.post(`api/ecard/error/record/list`, params);
  if (status == 200) {
      return result
  }
  return [];
}

/*
 *更新领卡提示信息
 */
async function ecardErrorTipUpdate(params) {
  let { data: { message, result, status } } = await httpClient.post(`api/ecard/error/tip/update`, params);
  if (status == 200) {
      return result
  }
  return [];
}

/**
 *超管查询云瓣校园小程序设置信息
 * @param {*} params
 */
async function getminicampusorg(params) {
    let  { data } = await httpClient.get('api/super/minicampus/org', {params});
    return data;
}

/**
 * 超管更新云瓣校园小程序信息
 * @param {*} params
 */
async function setminicampusorg(params) {
    let  { data } = await httpClient.post('api/super/minicampus/org', params);
    return data;
}

/**
 *超管查询云瓣校园小程序界面信息
 * @param {*} params
 */
async function getminicampuscardtypes(params) {
    let  { data } = await httpClient.get('api/super/minicampus/cardtypes', {params});
    return data;
}

/**
 * 超管设置云瓣校园小程序界面信息
 * @param {*} params
 */
async function setminicampuscardtype(params) {
    let  { data } = await httpClient.post('api/super/minicampus/set/cardtype', params);
    return data;
}


/**
 * 管理员校园码小程序腰封轮播图设置
 * @param {*} params
 */
async function globalSwiper(params) {
    if (!params.url) {
        params.url = `api/super/minicampus/global/swiper`
    }
    let { data } = await httpClient(params);
    return data;
}

/**
 * 超管获取云瓣校园小程序应用分组列表
 * @param {校园卡ID} id
 */
async function getCampusGroupList(id, orgId, platForm) {
    let { data: { message, result, status } } = await httpClient.get(`api/super/page/navigation/group`, { params: { id, orgId, platForm: platForm, appType: "MINI_CAMPUS"} });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 获取云瓣校园小程序导航列表
 * @param {校园卡ID} id
 */
async function getCampusNavigationList(id, platForm) {
    let { data: { message, result, status } } = await httpClient.get(`api/super/page/navigation/list`, { params: { id, platForm: platForm, appType: "MINI_CAMPUS" } });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 获取超管认证管理信息
 * @param {校园卡ID} id
 */
async function getVerifyInfo(params) {
    let { data } = await httpClient.get(`api/organization/verify/info`, { params });
    return data;
}

/**
 * 管理员设置平台用户认证类型
 * @param {*} params
 */
async function setVerifyType(params) {
    let  { data } = await httpClient.post('api/organization/set/verify/type', params);
    return data;
}

/**
 *管理员查询云瓣校园小程序界面信息
 * @param {*} params
 */
async function getminicampuscardtypesadmin(params) {
    let  { data } = await httpClient.get('api/admin/minicampus/cardtypes', {params});
    return data;
}

/**
 * 管理员设置云瓣校园小程序界面信息
 * @param {*} params
 */
async function setminicampuscardtypeadmin(params) {
    let  { data } = await httpClient.post('api/admin/minicampus/set/cardtype', params);
    return data;
}

/**
 * 管理员获取云瓣校园小程序应用分组列表
 * @param {校园卡ID} id
 */
async function getCampusGroupListAdmin(id, platForm) {
    let { data: { message, result, status } } = await httpClient.get(`api/page/navigation/group`, { params: { id, platForm: platForm, appType: "MINI_CAMPUS"} });
    if (status == 200) {
        return result
    }
    return [];
}

/**
 * 管理员查询云瓣校园小程序开通通道
 * @param {*} params
 */
async function getMinicampusPlatformAdmin(params) {
    let { data } = await httpClient.get(`api/admin/minicampus/platforms`, { params });
    return data;
}

/**
 * 超管获取有效期
 * @param {*} params
 */
async function getSysorgExpireList(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/superadmin/sysorg/expire/list`, params);
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 超管查看学校设置有效期记录
 * @param {*} params
 */
async function getSysorgExpireRecords(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/superadmin/sysorg/expire/records`, params);
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 超管设置学校有效期
 * @param {*} params
 */
async function setSysorgExpire(params) {
    let  { data } = await httpClient.post('api/superadmin/sysorg/expire/set', params);
    return data;
}

/**
 * 管理员获取通知
 * @param {*} params
 */
async function getSysnoticeDetail(params) {
    let { data: { message, result, status } } = await httpClient.get(`api/admin/sysnotice/detail`, { noLoading: true });
    let sysDetail = {}
    if (status == 200) {
        sysDetail = result
    }
    return sysDetail
}

/**
 * 管理员通知已读
 * @param {*} params
 */
async function sysnoticeRead(params) {
    let  { data } = await httpClient.post('api/admin/sysnotice/read', params);
    return data;
}

/**
 * 超管获取通知列表
 * @param {*} params
 */
async function sysnoticeList(params) {
    let { data: { message, result, status } } = await httpClient.post(`api/superadmin/sysnotice/list`, params);
    if (status == 200) {
        return result
    }
    return {};
}

/**
 * 超管设置弹框
 * @param {*} params
 */
async function sysnoticeOrgSet(params) {
    let  { data } = await httpClient.post(`api/superadmin/sysnotice/org/set`, params);
    return data;
}

/**
 * 超管添加通知
 * @param {*} params
 */
async function sysnoticeCreate(params) {
    let { data } = await httpClient(params);
    return data;
}
/**
 * 获取图片验证码
 * @param {*} params
 */
async function getCaptcha(params) {
   let { data } = await httpClient.post(`api/captcha/get`, params);
   return data;
}
/**
 * 校验图片验证码
 * @param {*} params
 */
async function checkCaptcha(params) {
   let { data } = await httpClient.post(`api/captcha/check`, params);
   return data;
}
export {
    login,
    qrLogin,
    logout,
    updatePassword,
    getQRCode,
    checkQRCodeStatus,
    getLeftMenuList,
    getUserInfo,
    getOrgInfo,
    getPlatform,
    goBackAdmin,
    getECardStatis,
    getECardActiveInfo,
    getECardUserList,
    exportECardUserList,
    toggleUserStatus,
    CRUD_DEPARTMENT,
    CRUD_BATCH_USER,
    getECardList,
    uploadFile,
    importECardExcel,
    CRUD_USER,
    getPrivilege,
    getPrivilegeList,
    getPayChannels,
    exportTradeInfo,
    getConsumeDataList,
    CRUD_ECARD,
    refreshUser,
    getUserLimitFields,
    getLevel2Dept,
    batchDelDept,

    getAliPayIconList,
    getNavigationList,
    getAliPayGroupList,
    createAliPayGroup,
    deleteAliPayGroup,
    updateAliPayGroup,
    updateAliPayGroupListSort,
    CRUD_NAVIGATION,
    updateNavigationListSort,
    publishEcard,
    getAliPayDeleteNavigationList,

    getWeChatPayIconList,
    getWeChatPayNavigationList,
    getWeChatPayGroupList,
    createWeChatPayGroup,
    deleteWeChatPayGroup,
    updateWeChatPayGroup,
    updateWeChatPayGroupListSort,
    CRUD_WECHATPAY_NAVIGATION,
    updateWeChatPayNavigationListSort,
    updateWechatPaySample,

    getUniPayGroupList,
    createUniPayGroup,
    deleteUniPayGroup,
    updateUniPayGroup,
    updateUniPayGroupListSort,
    CRUD_UNIPAY_NAVIGATION,
    getUniPayNavigationList,
    updateUniPayNavigationListSort,
    updateUniPaySample,
    getUniPayDeleteNavigationList,

    getWeChatPayDeleteNavigationList,
    getGuideList,
    CRUD_GUIDE,
    CRUD_PRIVILEGE,
    uploadImage,
    getRecordList,
    CRUD_APPLICATION,
    getPublicKey,
    CRUD_MACHINE,
    CRUD_SUBADMIN,

    getOrganizationList,
    getOrgAdd,
    getOrgUpdate,
    getOrganizationStatus,
    getAdminCode,
    getAdminStatus,
    getValidTypes,
    getAliPayApp,
    getWeChatApp,
    getPhoneApp,
    getAliPay,
    getWeChatPay,
    getUniPay,
    setPhoneVerifyType,
    getChangeSchool,
    getOrgs,
    getTestUserList,
    getDepartment,
    getAddbach,
    getUpdbach,
    getDelbach,
    getQuick,
    bind,
    unbind,
    getTypeNavigation,
    MANAGE_WITHHOLD,
    dkSetStatus,
    dkUserList,
    importUserExcel,
    userBind,
    userUnBind,
    userDetail,
    setupCardStatus,
    cardexplainList,
    cardexplainStatus,
    cardexplainSort,
    cardexplainUpdate,
    cardexplainCreate,
    cardexplain,
    setupWalletStatus,
    userEnable,
    setRealverify,
    getAdminList,
    menuList,
    MENU_ACTION,
    adminMenuSort,
    adminMenuGet,
    adminMenuSet,
    getECardUserImportList,
    getECardUserImportDetail,
    getECardUserExportList,
    importECardUser,
    exportECardUser,
    getPhoneNameList,
    PHONE_MANAGE,
    phoneUnbind,
    phoneListUnbind,
    phoneListDelete,
    importPhoneImport,
    getPhonePoolList,
    PHONE_POOL,
    phonePoolUnbind,
    phonePoolListUnbind,
    phonePoolListDelete,
    importPhonePoolImport,
    getPhoneNumberList,
    PHONE_NUMBER,
    phoneNumberUnbind,
    phoneNumberListUnbind,
    phoneNumberListDelete,
    importPhoneNumberImport,
    getPhoneSubmenu,
    setSchoolCode,
    getSchoolApp,
    exportPhoneNumberList,
    getPhoneNumberExportList,
    exportPhoneNumber,
    getWxCode,
    exportK12UserList,
    getAuth,
    getK12Count,
    closeK12WeChat,
    getK12Ali,
    getK12WeChat,
    closeAliK12,
    setAliK12,
    closeKidsSuper,
    getToken,
    getK12GroupList,
    createK12Group,
    deleteK12Group,
    updateK12Group,
    updateK12GroupListSort,
    getK12NavigationList,
    updateK12ListSort,
    getWechatNavigationList,
    getWechatGroupList,
    ecardErrorTip,
    ecardErrorRecordList,
    ecardErrorTipUpdate,
    getminicampusorg,
    setminicampusorg,
    getminicampuscardtypes,
    setminicampuscardtype,
    globalSwiper,
    getCampusNavigationList,
    getCampusGroupList,
    getVerifyInfo,
    setVerifyType,
    getminicampuscardtypesadmin,
    setminicampuscardtypeadmin,
    getCampusGroupListAdmin,
    getMinicampusPlatformAdmin,
    getInterimCard,
    getCardTypeList,
    updateInterimCard,

    getSysorgExpireList,
    getSysorgExpireRecords,
    setSysorgExpire,
    getSysnoticeDetail,
    sysnoticeRead,
    sysnoticeList,
    sysnoticeOrgSet,
    sysnoticeCreate,
    getCaptcha,
    checkCaptcha
}



// WEBPACK FOOTER //
// ./src/api/index.js